import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-compare-slider',
  templateUrl: './compare-slider.component.html',
  styleUrls: ['./compare-slider.component.less']
})
export class CompareSliderComponent implements OnInit, AfterViewInit {
  
  // I hope this over-commenting helps. Let's do this!
 // Let's use the 'this.active' variable to let us know when we're using it
 // and define our dom elements to make it easier to read
 public scrollerMiddle: HTMLElement = null;
 public scrollerTop: HTMLElement = null;
 public active: string | boolean = false;

  constructor() {
    
  }

  ngAfterViewInit(): void {
    // Let's set our opening state based off the width, 
    // we want to show a bit of both images so the user can see what's going on
    setTimeout(() => {
      this.active = "middle";
      this.scrollIt(430);
      this.active = "top";
      this.scrollIt(180);
      this.active = false;
    });
  }

  ngOnInit() {
    this.scrollerMiddle = <HTMLElement>document.querySelector('.scroller-middle');
    this.scrollerTop = <HTMLElement>document.querySelector('.scroller-top');
    this.active = false;

    // First we'll have to set up our event listeners
    // We want to watch for clicks on our scroller
    this.scrollerMiddle.addEventListener('mousedown', () => {
      this.active = "middle";
      // Add our scrolling class so the scroller has full opacity while this.active
      this.scrollerMiddle.classList.add('scrolling');
    });
    // We also want to watch the body for changes to the state,
    // like moving around and releasing the click
    // so let's set up our event listeners
    document.body.addEventListener('mouseup', () => {
      this.active = false;
      this.scrollerMiddle.classList.remove('scrolling');
    });
    document.body.addEventListener('mouseleave', () => {
      this.active = false;
      this.scrollerMiddle.classList.remove('scrolling');
    });
    // We'll have to do the same for our top scroller
    this.scrollerTop.addEventListener('mousedown', () => {
      this.active = "top";
      this.scrollerTop.classList.add('scrolling');
    });
    document.body.addEventListener('mouseup', () => {
      this.active = false;
      this.scrollerTop.classList.remove('scrolling');
    });
    document.body.addEventListener('mouseleave', () => {
      this.active = false;
      this.scrollerTop.classList.remove('scrolling');
    });

    // Let's figure out where their mouse is at
    document.body.addEventListener('mousemove', (e) => {
      if (!this.active) return;
      // Their mouse is here...
      let x = e.pageX;
      // but we want it relative to our wrapper
      x -= document.querySelector('.wrapper').getBoundingClientRect().left;
      // Okay let's change our state
      this.scrollIt(x);
    });

    // And finally let's repeat the process for touch events
    // first our middle scroller...
    this.scrollerMiddle.addEventListener('touchstart', () => {
      this.active = "middle";
      this.scrollerMiddle.classList.add('scrolling');
    });
    document.body.addEventListener('touchend', () => {
      this.active = false;
      this.scrollerMiddle.classList.remove('scrolling');
    });
    document.body.addEventListener('touchcancel', () => {
      this.active = false;
      this.scrollerMiddle.classList.remove('scrolling');
    });

    // then scroller top, our second scroller
    this.scrollerTop.addEventListener('touchstart', () => {
      this.active = "top";
      this.scrollerTop.classList.add('scrolling');
    });
    document.body.addEventListener('touchend', () => {
      this.active = false;
      this.scrollerTop.classList.remove('scrolling');
    });
    document.body.addEventListener('touchcancel', () => {
      this.active = false;
      this.scrollerTop.classList.remove('scrolling');
    });

    document.querySelector('.wrapper').addEventListener('touchmove', (e) => {
      if (!this.active) return;
      e.preventDefault();
      let x = e.touches[0].pageX;
      x -= document.querySelector('.wrapper').getBoundingClientRect().left;
      this.scrollIt(x);
    });
  }

   // Let's use this function
   public scrollIt(x) {
    // Calculate our transform
    let transform = Math.max(0, (Math.min(x, (<HTMLElement>document.querySelector('.wrapper')).offsetWidth)));
    // we show all our bottom image but how much of our middle and top,
    // that'll depend on what we're dragging
    // if we're dragging the middle slider
    if (this.active === "middle") {
      (<HTMLElement>document.querySelector('.middle')).style.width = transform + "px";
      this.scrollerMiddle.style.left = transform - 25 + "px";
      // if we're using scroller-middle, middle must always be to the right of top
      if (this.scrollerTop.getBoundingClientRect().left > this.scrollerMiddle.getBoundingClientRect().left - 5) {
        (<HTMLElement>document.querySelector('.top')).style.width = transform - 5 + "px";
        this.scrollerTop.style.left = transform - 30 + "px";
      }
    }
    // if we're dragging the top slider
    if (this.active === "top") {
      (<HTMLElement>document.querySelector('.top')).style.width = transform + "px";
      this.scrollerTop.style.left = transform - 25 + "px";
      // if we're using scroller-top, top must always be to the left
      if (this.scrollerTop.getBoundingClientRect().left > this.scrollerMiddle.getBoundingClientRect().left - 5) {
        (<HTMLElement>document.querySelector('.middle')).style.width = transform + 5 + "px";
        this.scrollerMiddle.style.left = transform - 20 + "px";
      }
    }
  }

}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/compare-slider/compare-slider.component.ts